import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, deleteInArray, GET, IfElse, Model, QueryDetail, QueryOrder, QueryParam, updateInArray } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'

export default function Kvoti(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, sourceKey, create } = props;
    const dispatch = useDispatch();

    const filters = () => [
        {
            label: "Категория",
            name: "kategoriya",
            display: (item) => {
                return item?.kategoriyaUchastnikov?.nazvanie + ", " + item?.tantsevalnayaDistsiplina?.nazvanie
            },
            queryFilter: [
                QueryDetail("model"),
                QueryParam("w-seriya", object?.ID),
                QueryOrder("kategoriyaUchastnikov.nazvanie", "ASC"),
                QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC")
            ],
            sort: true,
            filter: true,
        },
        {
            label: "Квота партнеры",
            name: "kvotaPartneri",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Квота партнерши",
            name: "kvotaPartnershi",
            type: "int",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
    ];

    return (
        <>
            <CollectionServer
                name={"Kvoti"}
                auth={auth}
                size="small"
                source={`/api/kvoti${(!create) ? "/com" : ""}/byseriya/${object.ID}`}
                filters={filters}
                mode={"list"}
                render={(item, idx, { setCollection, setCollectionItem, update }) => {
                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", paddingRight: "18px" }}>
                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q3" style={{ fontWeight: "600", textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Категория: </span>
                                    <span>{item?.kategoriya?.kategoriyaUchastnikov?.nazvanie}, {item?.kategoriya?.tantsevalnayaDistsiplina?.nazvanie}</span>
                                </div>
                                <div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Квота партнеры: </span>
                                    <span>{item?.kvotaPartneri}</span>
                                </div>
                                <div key="q5" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Квота партнерши: </span>
                                    <span>{item?.kvotaPartnershi}</span>
                                </div>

                            </div>
                        </div>
                    )
                }}
                collectionActions={() => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    kategoriyaID: values.kategoriyaID,
                                    kvotaPartneri: values.kvotaPartneri,
                                    kvotaPartnershi: values.kvotaPartnershi,
                                }
                                POST(auth, `/api/kvoti/new`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Категория",
                                    name: "kategoriya",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item?.kategoriyaUchastnikov?.nazvanie + ", " + item?.tantsevalnayaDistsiplina?.nazvanie
                                        },
                                        reference: { object: "KategoriiUchastnikovSerii", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryParam("w-seriya", object?.ID),
                                        QueryOrder("kategoriyaUchastnikov.nazvanie", "ASC"),
                                        QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC")
                                    ]
                                },
                                {
                                    label: "Квота партнеры",
                                    name: "kvotaPartneri",
                                    type: "int",
                                },
                                {
                                    label: "Квота партнерши",
                                    name: "kvotaPartnershi",
                                    type: "int",
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить квоты",
                            modal: {
                                width: "600px",
                                title: <div>
                                    <div>Добавить квоты</div>
                                    <div style={{ fontSize: "14px" }}>{object?.nazvanie} {(object?.sezon?.nazvanie) ? "(" + object?.sezon?.nazvanie + ")" : ""}</div>
                                </div>
                            }
                        }], []),
                ]}
                modelActions={(item) => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    ID: item.ID,
                                    kategoriyaID: item.kategoriyaID,
                                    kvotaPartneri: values.kvotaPartneri,
                                    kvotaPartnershi: values.kvotaPartnershi,
                                }
                                POST(auth, `/api/kvoti/update`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            object: item,
                            form: Model,
                            meta: [
                                {
                                    type: "func",
                                    render: () => {
                                        return (<div style={{paddingBottom: "10px"}}>
                                            <span>Категория: </span>
                                            <span>{item?.kategoriya?.kategoriyaUchastnikov?.nazvanie}, {item?.kategoriya?.tantsevalnayaDistsiplina?.nazvanie}</span>
                                        </div>)
                                    }
                                },
                                {
                                    label: "Квота партнеры",
                                    name: "kvotaPartneri",
                                    type: "int",
                                },
                                {
                                    label: "Квота партнерши",
                                    name: "kvotaPartnershi",
                                    type: "int",
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Изменить квоты",
                            modal: {
                                width: "600px",
                                title: <div>
                                    <div>Изменить квоты</div>
                                    <div style={{ fontSize: "14px" }}>{object?.nazvanie} {(object?.sezon?.nazvanie) ? "(" + object?.sezon?.nazvanie + ")" : ""}</div>
                                </div>
                            }
                        }], []),
                    ...IfElse(
                        (create == true), [
                        {
                            danger: true,
                            title: "Удалить",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/kvoti/delete/${item.ID}`,
                                    () => setCollection(deleteInArray(collection, item)), errorCatch
                                );
                            },
                        }], []),
                ]}
            />
        </>
    );
}
